<template>
    <div ref="footerBgContainer" id="chuangFooter">
        <div class="row overwrite-row">
            <div class="col s12 m5 l5 xl5">
                <div class="hide-on-small-only footer-logo clearfix">
                    <img class="right" src="../assets/images/logo-pc.png" alt="">
                </div>
                <div class="hide-on-med-and-up footer-logo clearfix">
                    <img class="right" src="../assets/images/logo-pc.png" alt="">
                </div>
            </div>
            <div class="col s12 m7 l7 xl7">
                <div class="footer-info">
                    <p v-text="footerLanguages[selectedLanguage].address" ></p>
                    <div class="row contact-info">
                        <div class="col s12 m12 l4 vl4">
                            <p v-text="footerLanguages[selectedLanguage].tel"></p>
                        </div>
                        <div class="col s12 m12 l10 vl10">
                              <p v-text="footerLanguages[selectedLanguage].fax"></p>
                        </div>
                    </div>
                    <p>© 2017 Copyright Chuangle co.ltd</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                clientWidth: 0,
                footerLanguages: 
                [
                    {
                        address: '公司地址：台北市內湖區內湖路一段120巷15弄8號5樓',
                        tel: '電話: (02) 2658-9898',
                        fax: '傳真: (02)2658-3598'
                    },
                    {
                        address: '公司地址：台北市内湖区内湖路一段120巷15弄8号5楼',
                        tel: '电话: (02) 2658-9898',
                        tfaxel2: '传真: (02) 2658-3598'
                    },
                    {
                        address: '5F No.8, Aly. 15, Ln.120, Sec. 1, Neihu Rd., Neihu Dist., Taipei City 114, Taiwan(R.O.C)',
                        tel: 'TEL: (02) 2658-9898',
                        fax: 'FAX: (02) 2658-3598'
                    }
                ],
                selectedLanguage: 0
            }
        },
        methods: {
            changeIntroBackground(){
                if(this.clientWidth <= 900) {
                    this.$refs.footerBgContainer.style.backgroundImage = "url("+ require('../assets/images/footer-bg-mobile.png') + ")";

                } else if (this.clientWidth > 900) {
                    this.$refs.footerBgContainer.style.backgroundImage = "url("+ require('../assets/images/footer-bg.png') + ")";

                }
            }
        },
        mounted() {
            let _this = this;
            this.$root.$on('languageChange', function(e){
                _this.selectedLanguage = parseInt(e);
            })
            window.addEventListener('resize', function(e){
                _this.clientWidth = document.getElementById('chuangFooter').clientWidth;
                _this.changeIntroBackground();
            });
            window.addEventListener('load', function(e){
                _this.clientWidth = document.getElementById('chuangFooter').clientWidth;
                _this.changeIntroBackground();
            });
        }
    }
</script>

<style lang="less" scoped>
@import url('../assets/css/base.less');
    .overwrite-row {
        margin-bottom: none!important;
    }
    #chuangFooter {
        padding-top: 4rem;
        padding-bottom: 4rem;
        background: url('../assets/images/footer-bg.png') no-repeat center;
        background-size: cover; 
        min-width: @min-width;
        @media @768 {
            padding-top: 0;
            padding-bottom: 0;
        }
        .row {
            @media @768 {
                padding: 35px;
            }
            @media @479 {
                padding: 20px;
            }
            @media @360 {
                padding: 20px;
            }
            @media @320 {
                padding: 20px;
            }
        }
        .contact-info {
            padding: 0;
            div {
                padding: 0;
            }
        }
        .footer-logo{
            margin-right: 2rem;
            margin-bottom: 1rem;
            float: right;
            width: 9rem;
            // margin-top: 1.5rem;
            @media @990 {
                float: right;
            }
            @media @768 {
                float: right;
            }
            @media @footerCol {
                float: left;
                width: 9rem;
            }
            @media @479 {
                float: left;
                width: 9rem;
            }   
            img {
                width: 100%;
                webkit-box-shadow: 1px 1px 5px 0px rgba(0,0,0,0.75);
                -moz-box-shadow: 1px 1px 5px 0px rgba(0,0,0,0.75);
                box-shadow: 1px 1px 5px 0px rgba(0,0,0,0.75);
                border-radius: 10px 10px 10px 10px;
                -moz-border-radius: 10px 10px 10px 10px;
                -webkit-border-radius: 10px 10px 10px 10px;
                border: 0px solid #000000;
                border-radius: 15px 15px 15px 15px;
                -moz-border-radius: 15px 15px 15px 15px;
                -webkit-border-radius: 15px 15px 15px 15px;
                border: 0px solid #000000;
            }
        }
        .footer-info {
            color: #e5e5e5;
            line-height: 2rem;
            text-align: left;
            font-size: @cons-description-text-size-1920;
            @media @990 {
                font-size: @cons-description-text-size-1920;
            }
            @media @768 {
                font-size: @cons-description-text-size-1920;
            }
            @media @479 {
                font-size: @cons-description-text-size-1920 - 0.4;
            }
            @media @360 {
                font-size: @cons-description-text-size-1920 - 0.5;
            }   
            @media @320 {
                font-size: @cons-description-text-size-1920 - 0.3;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/ChuangFooter.vue